import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { DestroyOptions } from "pixi.js";
import { LOGO_Y, VISIBLE_SYMBOLS_PER_REEL } from "../config/reelConfig";
import { DisplayObject, IDisplayObject } from "../core/displays/DisplayObject";


export class Logo extends DisplayObject {
    private logo: Spine | null = null;

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
    }

    public override destroy(options?: DestroyOptions): void {
        super.destroy(options);
    }

    public playIdle() {
        this.logo.state.setAnimation(0, "idle", true);
    }

    public playWin() {
        this.logo.state.setAnimation(0, "win", true);
    }

    public playShake() {
        this.logo.state.setAnimation(0, "shake", false);
    }

    public override setPositionResize(orientation: string) {
        if (orientation === "LANDSCAPE") {
            this.setPosition(this.config.landscape.posX, this.config.landscape.posY);
            this.setScale(this.config.landscape.scale, this.config.landscape.scale);
        } else {
            this.setPosition(this.config.portrait.posX, LOGO_Y[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)]);
            this.setScale(this.config.portrait.scale, this.config.portrait.scale);
        }
    }

    private init(): void {
        this.logo = Spine.from({
            skeleton: "logoSkel",
            atlas: "logoAtlas",
        });
        this.logo.label = "logo";
        this.addChild(this.logo);
        this.logo.state.setAnimation(0, "idle", true);
    }
}
